/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InstitutionalMaterialAliases {
  INSTITUTIONAL_MATERIAL_CHECK_ACTION = 'institutional-material-check-action',
  INSTITUTIONAL_MATERIAL_CONTEXTUAL_BAR = 'institutional-material-contextual-bar',
  INSTITUTIONAL_MATERIAL_FETCH = 'institutional-material-fetch',
  INSTITUTIONAL_MATERIAL_HTML_VIEWER = 'institutional-material-html-viewer',
  INSTITUTIONAL_MATERIAL_LAYOUT = 'institutional-material-layout',
  INSTITUTIONAL_MATERIAL_MAPPER = 'institutional-material-mapper',
  INSTITUTIONAL_MATERIAL_PANEL = 'institutional-material-panel',
  LAYOUT_CONTETUALBAR_CONTENT = 'layout-contetualbar-content',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { InstitutionalMaterialAliases };
